import { FMatQuadrantGraphNode, FMatQuadrantRenderer } from "@dino/shared"
import React, { useMemo } from "react"
import { useParams } from "react-router-dom"
import { useDinoPaperQuery } from "../../../generated-types"
import { ResultLayout } from "./ResultLayout"
import { FMatDesc } from "./FMatDesc"

export default () => {
  const { paperId } = useParams()
  const { data } = useDinoPaperQuery({ variables: { paperId } })

  const value = useMemo(() => {
    if (!data) return []
    const { results } = data.dinoPaper
    return [results[0], results[1], results[2], results[3]]
  }, [data])

  return (
    <ResultLayout extraContent={<FMatDesc pgmId={data?.dinoPaper?.item?.id} value={value} />}>
      {({ width, refStage }) => (
        <FMatQuadrantRenderer width={width} ref={refStage}>
          {value.length >= 4 && <FMatQuadrantGraphNode value={value} />}
        </FMatQuadrantRenderer>
      )}
    </ResultLayout>
  )
}
